<template>
  <input :id="id" :name="name" :value="chosenVariant ? chosenVariant : null" type="hidden" />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "VariantPickerProductHiddenField",
  props: {
    name: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    productMaster: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
    }),
  },
};
</script>
